import styled, { css } from "styled-components";

export const ContainerIntegracaoTiny = styled.div`
  color: ${(props) => props.theme.colors.tertiary};
  .textoTiny{
      text-align: left;
      padding: 3rem 0;
      width: 100%;
      color: ${(props) => props.theme.colors.tertiary};
      position: relative;

      &::after {
        content: '';
        position: absolute;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
        width: 30%;
        height: 2px;
        border-radius: 100%;
        background-color: ${(props) => props.theme.colors.elements};
      }
    }
  .config {
    display: flex;
    align-items: center;
    margin: 2rem 0;
    .title {
      margin-left: 2rem;
      text-align: left;
      &.bloqueado {
        opacity: 0.5;
      }
    }
    > .locked-icon {
      margin-left: 1.5rem;
    }
  }

  /* Grupo de configurações de envio de pedido: por fora respeita o respiro de
     3rem usado entre os blocos, por dentro as linhas seguem o padrão do .config */
  .grupoPedidos {
    margin: 3rem 0;

    > .config:first-child {
      margin-top: 0;
    }
    > .config:last-child {
      margin-bottom: 0;
    }
  }

  .configs {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 3rem;
    margin-top: 3rem;
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
  .radioGroup {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
    margin: 3rem 0;

    .radioTitle {
      margin-bottom: 0.5rem;
    }

    .radioLabel {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      cursor: pointer;
      &.bloqueado {
        cursor: default;
        > span {
          opacity: 0.5;
        }
      }
      > .locked-icon {
        margin-left: 0.5rem;
      }
    }
  }
  .obs{
    text-align: justify;
    padding: 3rem 0;
  }
  .urlContainer{
    text-align: left;
    .url{
      cursor: pointer;
      color: ${(props) => props.theme.colors.primary};
      text-align: left;
      &:hover{
        text-decoration: underline;
      }
    }
  }
`;
